document.addEventListener('DOMContentLoaded', function () {

    const wishlist_count = document.querySelector('.wishlist-count');

    let wishlist = JSON.parse(localStorage.getItem('wishlist')) || [];
    const count = wishlist.length;

    if (wishlist_count) wishlist_count.textContent = count;

    document.querySelectorAll('.wishlist-btn').forEach((btn) => {
        const handle = btn.getAttribute('data-handle');

        if (wishlist.includes(handle)) {
        btn.classList.add('active_wishlist');
        }
    });

    const wishlist_pdp = document.querySelector('.wishlist-pdp-btn');
    if(wishlist_pdp){
      const handle = wishlist_pdp.getAttribute('data-handle');
      if (wishlist.includes(handle)) {
        wishlist_pdp.classList.add('active_pdp_wishlist');
      }
    }

});

document.addEventListener('click', function (e) {
  if (e.target.closest('.wishlist-btn')) {
    const wishlist_count = document.querySelector('.wishlist-count');
    const btn = e.target.closest('.wishlist-btn');
    const handle = btn.getAttribute('data-handle');

    let wishlist = JSON.parse(localStorage.getItem('wishlist')) || [];

    if (wishlist.includes(handle)) {
      wishlist = wishlist.filter(item => item !== handle);
      btn.classList.remove('active_wishlist');
    } else {
      wishlist.push(handle);
      btn.classList.add('active_wishlist');
    }

    localStorage.setItem('wishlist', JSON.stringify(wishlist));

    const count = wishlist.length;
    if (wishlist_count) wishlist_count.textContent = count;
  }

  if (e.target.closest('.wishlist-pdp-btn')) {
    const wishlist_count = document.querySelector('.wishlist-count');
    const btn = e.target.closest('.wishlist-pdp-btn');
    const handle = btn.getAttribute('data-handle');

    let wishlist = JSON.parse(localStorage.getItem('wishlist')) || [];

    if (wishlist.includes(handle)) {
      wishlist = wishlist.filter(item => item !== handle);
      btn.classList.remove('active_pdp_wishlist');
    } else {
      wishlist.push(handle);
      btn.classList.add('active_pdp_wishlist');
    }

    localStorage.setItem('wishlist', JSON.stringify(wishlist));

    const count = wishlist.length;
    if (wishlist_count) wishlist_count.textContent = count;
  }

});